// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { ApexOptions } from "apexcharts";
// Custom components
import Card from "components/Card/Card";
import DrawerDashboard from "components/Dashboard/Drawer";
import { formatedDateBr } from "helpers/formated";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";

import { MdBarChart, MdOutlineCalendarToday } from "react-icons/md";
// Assets

export default function TotalSpent(data: any) {
  // Chakra Color Mode
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [idSelect, setIdSelect] = useState(0);

  const textColor = useColorModeValue("secondaryGray.900", "white");

  const themeTooltip = useColorModeValue("light", "dark");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const abrirDrawer = (id?: any) => {
    setIdSelect(id);
    setIsOpenDrawer(true);
  };

  const fecharDrawer = () => {
    setIdSelect(0);
    setIsOpenDrawer(false);
  };
  const seriesData = [
    {
      name: "Agendado",
      data: [
        data?.data?.dataShowingFerragem[0],
        data?.data?.dataShowingChaparia[0],
      ],
    },
    {
      name: "Disponível",
      data: [
        data?.data?.dataShowingFerragem[1],
        data?.data?.dataShowingChaparia[1],
      ],
    },
    {
      name: "Excedido",
      data: [
        data?.data?.dataShowingFerragem[2],
        data?.data?.dataShowingChaparia[2],
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      formatter: function (val: number) {
        return val ? val + "%" : "";
      },
    },
    xaxis: {
      categories: ["Ferragem", "Chaparia"],
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    yaxis: {
      min: 0,
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    colors: ["#368d61", "#FFD700", "#FF0000"],
    tooltip: {
      theme: themeTooltip,
      y: {
        formatter: function (val: any) {
          return val + "%"; // Adiciona o símbolo de porcentagem apenas no tooltip
        },
      },
    },

    legend: {
      labels: {
        colors: textColor,
      },
    },
  };
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb="0px"
    >
      <Flex align="center" justify="space-between" w="100%" pe="20px" pt="5px">
        <DrawerDashboard
          id={idSelect}
          isOpen={isOpenDrawer}
          fecharDrawer={fecharDrawer}
        />
        <Button
          bg="#005F3C"
          fontSize="sm"
          fontWeight="500"
          color="white"
          borderRadius="7px"
          cursor="pointer"
          onClick={() => {
            abrirDrawer(data?.data?.weekStart);
          }}
        >
          <Icon as={MdOutlineCalendarToday} color="white" me="4px" />
          Visão Dia
        </Button>
      </Flex>
      <Flex w="100%" flexDirection={{ base: "column", lg: "row" }}>
        <Flex flexDirection="column" me="20px" mt="28px">
          <Text
            color={textColor}
            fontSize="24px"
            textAlign="start"
            fontWeight="700"
            lineHeight="100%"
          >
            Semana: {formatedDateBr(data?.data?.weekStart)} -{" "}
            {formatedDateBr(data?.data?.weekEnd)}
          </Text>
        </Flex>
      </Flex>
      <Flex w="100%" flexDirection={{ base: "column", lg: "row" }}>
        <Box minH="360px" minW="90%" mt="auto">
          <ReactApexChart
            options={options as ApexOptions}
            series={seriesData}
            type="bar"
            height={350}
          />
        </Box>
      </Flex>
    </Card>
  );
}
